var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8166 16.9858C38.5916 17.0358 35.5712 17.7593 31.7012 20.2686C31.1198 17.3689 29.399 11.9394 24.3068 6.4175L23 5L21.6932 6.41935C16.583 11.9617 14.8694 17.4059 14.2934 20.3241C10.409 17.7723 7.412 17.0395 7.1924 16.9877L5 16.4843V18.7938C5 32.2841 12.065 41 23 41C33.7658 41 41 32.0768 41 18.7938V16.4954L38.8166 16.9858ZM17.5982 22.5651C17.6018 22.5041 17.8718 16.8285 23 10.4775C28.0652 16.7693 28.4 22.4948 28.4 22.4948V22.7261C26.3814 24.4507 24.5634 26.4092 22.982 28.5627C21.3962 26.4472 19.5909 24.5156 17.5982 22.802V22.5651ZM23 37.299C13.4312 37.299 9.4118 29.5342 8.7134 21.4511C11.6924 22.7798 17.0222 25.9405 21.506 32.7818L23.0198 35.0931L24.5048 32.7615C28.8716 25.8998 34.2698 22.7483 37.2776 21.4326C36.5612 29.2566 32.5472 37.299 23 37.299Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpa);
export default __webpack_public_path__ + "static/media/spa.b0b6c3286070cca1aaec7308521f88cb.svg";
export { ForwardRef as ReactComponent };